import Axios from 'axios'
import { applyJitter } from '../helpers/jitter'

const { REACT_APP_API_PRESENT } = process.env

if (!REACT_APP_API_PRESENT)
    console.error('REACT_APP_API-PRESENT to be declared on your system environments variables')

const baseURL = `${REACT_APP_API_PRESENT}`

export const ApiPresent = Axios.create({
    baseURL,
})

export const setUserPresent = async (courseId: string) => {
    await applyJitter()
    return ApiPresent.post<API<UserPresentDTO>>('/v1/presents', { courseId })
        .then(({ data }) => {
            if (!data.data.canSetPresent)
                sessionStorage.setItem(`require-present-${courseId}`, 'true')
            else sessionStorage.removeItem(`require-present-${courseId}`)
            return data.data
        })
        .catch(error => {
            const status: number | undefined = Axios.isAxiosError(error) ? error.response?.status : undefined
            // 429: candado de api-present por pedido duplicado (el clic en LIVE manda dos). Sin marca, para
            // no reintentar en masa los duplicados cuando llega `ui-team-has-updated`
            if (status === 429) {
                return { canSetPresent: false }
            }
            // Error de red sin respuesta o 5xx: se marca para que el reintento de `ui-team-has-updated`
            // (useActions) lo vuelva a mandar, en vez de perderlo sin rastro
            if (Axios.isAxiosError(error) && (!status || status >= 500)) {
                sessionStorage.setItem(`require-present-${courseId}`, 'true')
                return { canSetPresent: false }
            }
            throw error
        })
}

interface API<TData> {
    code: number
    message: string
    data: TData
}

type UserPresentDTO =
    | { canSetPresent: false }
    | {
          canSetPresent: true
          id: string
          present: boolean
          status: 'present' | 'absent'
          expiration: string // Date
          open: string // Date
          createdAt: string // Date
      }
